// @ts-check

export const reductionType = Object.freeze({
  DISCOUNT: 'DISCOUNT',
  SALES_COMMISSION: 'SALES_COMMISSION'
})

export const countryGroup = Object.freeze({
  FINLAND: 'finland',
  EU: 'eu',
  OTHER: 'other'
})
